import React, { Component } from 'react';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { Singleton } from '../../js/Singleton';
import { phoneIconGreenBorderless } from '../../Images/AlertsSVG'
import { tacheCirculo } from '../../Images/GenericSVG'

export default class ManualCallReprogrammed extends Component {
  constructor(props) {
    super(props);
    this.state = { onHiddeAlert: false }
    this.sharedData = new SingletonSharedData();
    this.language = new Singleton();
  }
  onClickHandler = () => {
    this.setState({ onHiddeAlert: true });
    this.props.onCancel();
  }
  render() {
    return (
      <div className={"manualCallReprogrammingContainer " + (this.state.onHiddeAlert ? "onHidde" : "")}>
        <div className="alertAbsolute">
          <div className="titleReprogramAlert">
            <div className="phoneIconMCR">{phoneIconGreenBorderless}</div>
            <p className="textMCR">{this.language.getText("GUIManualCallReprogrammed")}</p>
          </div>
          <p className="phoneMCR">{this.sharedData.getPhoneNumber()}</p>
          <div className="tacheIconMCR" onClick={this.onClickHandler}>{tacheCirculo}</div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Alerts/ManualCallReprogrammed.jsx